import axios from "axios";
// import {fetchFaqs,postContactUs} from '../api-urls';
import { API_ENDPOINTS } from "../api-urls";


// Function to submit the contact form
export const submitContactForm = async (formData) => {
  try {
    console.log("Submitting contact form...", formData);

    const response = await axios.post(API_ENDPOINTS.contactUs, formData);

    console.log("Contact Form Submission Success:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "Error submitting contact form:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// Function to fetch FAQs
export const fetchFAQs = async () => {
  try {
    console.log("Fetching FAQs...");

    const response = await axios.get(API_ENDPOINTS.faqs);

    console.log("FAQs Fetched Successfully:", response.data);
    return response.data; // Assuming API returns an array of FAQs
  } catch (error) {
    console.error("Error fetching FAQs:", error.response ? error.response.data : error.message);
    return []; // Return an empty array in case of an error
  }
};
